'use client';

import { Badge } from '@core/ui/primitives/badge';
import { Spinner } from '@core/ui/primitives/spinner';
import { cn } from '@core/helpers/misc/GeneralUtils';

interface FullPageLoaderProps {
  /** Additional class names */
  className?: string;
  /** Whether to show the loader with fade animation */
  isVisible?: boolean;
}

/**
 * Full-page loading overlay shown during initial app load.
 * Displays a centered spinner on the app background.
 * Fades out when isVisible becomes false.
 */
export function FullPageLoader({ className, isVisible = true }: FullPageLoaderProps) {
  return (
    <div
      className={cn(
        'full-page-loader fixed inset-0 z-[100] flex items-center justify-center',
        'bg-background transition-opacity duration-300',
        isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none',
        className
      )}
      aria-hidden={!isVisible}
      role='status'
      aria-label='Loading application'>
      <Badge variant='outline' className='gap-2 text-sm'>
        <Spinner />
        Loading
      </Badge>
    </div>
  );
}
